//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

import acornImage from '@images/acorn.svg';

import _ from "js/underscore-mixins";

(function() {
  angular.module('curalate')
        .directive('productTag', () => ({
          restrict: 'E',
          scope: {
            product: '=',
            class: '@',
            removeAction: '&',
          },
          replace: true,
          template: '<div class="product-tag clearfix {{ class }}" bindonce>' +
                              '<a ' +
                                    'class="pt-image pull-left" ' +
                                    'bo-style="{ \'background-image\': \'url(\' + (product.imageUrl  || acornImage) + \')\' }" ' +
                                    'ng-href="{{ product.url }}" ' +
                                    'target="_blank"></a>' +
                              '<div class="pt-details pull-left">' +
                                  '<div class="pt-name pull-left" bo-text="product.name"></div>' +
                                  '<div class="pt-price pull-left" bo-text="product.price"></div>' +
                              '</div>' +
                              '<span ng-show="removeAction" class="remove-product" ng-click="removeAction()"><i class="fa fa-times"></i></span>' +
                          '</div>',
          link(scope, elem, attrs) {
                    // Isolate-scoped objects of type '&' are always truthy because Angular wraps the supplied value in a function. This
                    // Will force removeAction to be null if there was no function passed in.
            scope.removeAction = _(attrs).has('removeAction') ? scope.removeAction : null;
            scope.acornImage = acornImage;
          },
        }),
    );
})();
